<template>
  <div class="content container">
    <div class="row">
      <div v-for="app,index in appList" class="col-lg-3 col-md-3 col-sm-3 col-xs-12 continfobox" id="list-box-64"
        data-tags="business" style="line-height:3em">
        <div class="appbox text-center">
          <div style="margin:1em">
            <img style="width: 5em;height: 5em;" class="app_logo" :src="app.iconUrl">
            <div style="margin:1em">
              <div class="app_field" style="text-align: left;">
                <i class="os_icon iconfont icon-ios"></i>
                &nbsp;&nbsp;
                <span style="color:#afafaf">{{app.appName}}</span>
              </div>
              <div v-clipboard:copy="_Global.SHORT_LINK_PREFIX+'app/mobileconfig/'+app.id"
                v-clipboard:success="copy_success" v-clipboard:error="copy_error" class="app_field"
                style="text-align: left;cursor: pointer;">
                <span class="text-overflow"
                  style="color:#afafaf">分发连接：{{_Global.SHORT_LINK_PREFIX+'app/mobileconfig/'+app.id}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">累计下载数: {{app.downloadNum}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">更新时间：{{app.updateTime | formatDateTime}}</span>
              </div>
              <div class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">发布时间：{{app.createTime| formatDateTime}}</span>
              </div>

              <div class="app_edit">
                <button @click="updateApp(app.id)" class="btn btn-outline-primary"
                  style="margin-right:0.5em">更新</button>
                <input @change="updateMobileConfig" type="file" id="updateMobileConfig" style="display:none">
                <button @click="preview(index)" class="btn btn-outline-primary" style="margin-right:0.5em">预览</button>
                <button @click="del_app(app.id)" class="btn btn-outline-primary">删除</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MobielConfigAppWindow v-if="show_upload_modal" :mobileConfigFile="mobileConfigFile" v-on:showModal="showModal">
    </MobielConfigAppWindow>
    <makeMobielConfigAppWindow v-if="make_config_modal" v-on:show_make_config_modal="show_make_config_modal" />
    <div class="modal" id="goods_pay" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel">商品列表</h4>
            <!-- <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> -->
          </div>
          <div class="modal-body">
            <div class="text-center">
              <div class="package-item ng-scope">
                <div class="package-content">
                  <div class="money ng-binding">￥289</div>
                  <div class="times ng-binding">10000</div>
                  <div class="unit">累计下载次数</div>
                  <div style="visibility: hidden" class="text-gift invisible">
                    { 赠
                    <span class="ng-binding">0</span> 次 }
                  </div>
                </div>
                <div class="package-actions">
                  <button type="button" class="btn-default" style="cursor: pointer" onclick="buy(1)">购买</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var self;
import uploadWindow from "./UploadWindow";
import MobielConfigAppWindow from "./MobielConfigAppWindow";
import makeMobielConfigAppWindow from "./MakeMobielConfigAppWindow";
export default {
  components: {
    uploadWindow,
    MobielConfigAppWindow,
    makeMobielConfigAppWindow
  },
  mounted: function() {
    self = this;
    var token = this.getToken();
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/mobileconfig/app/list", {
        authToken: token
      })
      .then(response => {
        self.respDataHandle(response.body, respData => {
          console.log("tag", respData);
          if (respData.length == 0) {
            this.$notify({
              title: "提示",
              type: "warning",
              message: "暂无免签应用记录",
              offset: 50
            });
          }
          this.appList = respData;
        });
      });
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/token", { authToken: token })
      .then(response => {
        self.respDataHandle(
          response.body,
          function(respData) {
            // console.log(respData);
            self.account = respData;
            self.$emit("setNoLogin", false);
            self.$emit("setAccount", respData);
          },
          function() {
            self.$router.push("/login");
          }
        );
      });

    this.$nextTick(() => {
      this.$refs.file_upload.ondragover = e => {
        e.preventDefault();
        e.stopPropagation();
      };
      this.$refs.file_upload.ondragleave = e => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
      };
      this.$refs.file_upload.ondrop = e => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
        var mobileConfigFile = e.dataTransfer.files[0];
        if (mobileConfigFile.name.search(".mobileconfig") == -1) {
          window.layer.msg("请上传mobileconfig类型的文件");
          return;
        }
        self.mobileConfigFile = mobileConfigFile;
        self.show_upload_modal = true;
      };
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      appList: [],
      show_upload_modal: false,
      mobileConfigFile: null,
      account: {},
      updateMobileConfigAppId: 0,
      make_config_modal: false
    };
  },
  methods: {
    preview: function(index) {
      var link =
        this._Global.SHORT_LINK_PREFIX +
        "app/mobileconfig/" +
        this.appList[index].id;
      window.open(link);
    },
    del_app: function(id) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/mobileconfig/app/delete", {
          mobileConfigId: id,
          authToken: this.getToken()
        })
        .then(response => {
          self.respDataHandle(response.body, function(data) {
            if (data == true) {
              window.location.reload();
            }
          });
        });
    },
    updateApp: function(id) {
      $("#updateMobileConfig").click();
      this.updateMobileConfigAppId = id;
    },
    updateMobileConfig: function(event) {
      var mobileConfigFile = event.target.files[0];
      if (mobileConfigFile.name.search(".mobileconfig") == -1) {
        window.layer.msg("请上传mobileconfig类型的文件");
        return;
      }
      var formData = new FormData();
      formData.append("mobileConfigId", this.updateMobileConfigAppId);
      formData.append("mobileConfigFile", mobileConfigFile);
      formData.append("authToken", this.getToken());

      this.startUpload = true;
      this.progress = 0;
      this.$http
        .post(
          this._Global.HTTP_SERVER + "/auth/mobileconfig/app/update",
          formData
        )
        .then(response => {
          window.location.reload();
        });
    },
    copy_success: function() {
      this.$message({
        message: "复制成功",
        type: "success"
      });
    },
    copy_error: function(e) {
      this.$message.error("Failed to copy texts");
    },
    click_upload: function() {
      $("#file").click();
    },
    file_change: function(event) {
      console.log("读取文件");
      var mobileConfigFile = event.target.files[0];
      if (mobileConfigFile.name.search(".mobileconfig") == -1) {
        window.layer.msg("请上传mobileconfig类型的文件");
        return;
      }
      this.mobileConfigFile = mobileConfigFile;
      this.show_upload_modal = true;
    },
    showModal: function(show_upload_modal) {
      this.show_upload_modal = show_upload_modal;
    },
    show_make_config_modal: function(modal) {
      this.make_config_modal = modal;
    },
    buyMobileConfigDown: function(params) {
      var num = prompt("请输入购买下载点数(1元/次) 购买点数不少于200次", "");

      if (num != "" && num != undefined && parseInt(num) >= 200) {
        window.open(
          this._Global.HTTP_SERVER +
            "/auth/pay/mobileconfig/down_num?num=" +
            num +
            "&authToken=" +
            this.getToken()
        );
      }
    }
  }
};
</script>

<style scoped>
.pay_down {
  text-align: right;
}

.pay_down p {
  padding: 0;
  color: #afafaf;
}

.pay_down h6 {
  padding: 0;
  margin: 0.4em;
}

.continfobox {
  position: relative;
  margin: 0.3em 3em 3em 3em;
}

.appbox {
  background-color: #fff;
  border-radius: 1em;
  position: relative;
  min-height: 25em;
  width: 22em;
  box-sizing: border-box;
  color: #707070;
  height: 100%;
}

.upload_icon {
  font-size: 100px;
}

.app_logo {
  width: 6em;
  margin-top: 1em;
  border-radius: 1em;
}

.app_field {
  margin-bottom: 1m;
}

.app_edit {
  margin-top: 1em;
}

button {
  width: 4.5em;
  border-radius: 10em;
}
.os_icon {
  font-size: 28px;
}

.make_mobileconfig {
  padding-top: 3em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/MobielConfigApp.vue